import React, { Component } from 'react'
import {MasterLayout} from 'layout';
import {DanhMucCuocThanhTraTrung} from 'modules/thanh-tra-trung'


export default class DanhMucCuocThanhTraTrungPage extends Component {
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <DanhMucCuocThanhTraTrung/>
      </MasterLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/thanh-tra-trung/DanhMucCuocThanhTraTrungPage.jsx